export const productType = {
    MOVIE: 1,
    MUSIC: 2,
    COLLECTION: 3,
    APK: 4,
    GENERIC_DATA: 5,
    IPA: 6,
    UGC: 7,
    QUIZ: 8,
    MIAC: 90
};

export const filterProductType = (id: number): boolean => {
    return [productType.MOVIE, productType.MUSIC, productType.COLLECTION   , productType.MIAC].includes(id);
};